"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChipGroup = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _index = require("../EncoreProvider/index.js");
var _index2 = require("../VisuallyHidden/index.js");
var _ChipGroup = require("./ChipGroup.js");
var _ChipGroupContext = require("./ChipGroupContext.js");
var _utils = require("./utils.js");
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index3 = require("../../styles/mixins/OverflowButton/index.js");
var _utils2 = require("../../utils.js");
var _excluded = ["mode", "layout", "children", "onKeyDown", "noItemsAssistiveText"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var modeOptions = ['single-select', 'multi-select', 'navigation', 'input', 'action'];
var getRole = function getRole(mode) {
  switch (mode) {
    case 'single-select':
      return 'radiogroup';
    case 'navigation':
      return 'navigation';
    default:
      return 'group';
  }
};

/**
 * ChipGroup provides layout and keyboard accessibility for child chip components.
 * It's meant to be used with the base ["next" Chip](https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-next-chip--docs),
 * [ChipFilter](https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-chipfilter--docs), or
 * [ChipInput](https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-chipinput--docs).
 *
 * Chips inside the `ChipGroup` are automatically configured to use the ["next" Chip](https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-next-chip--docs) lifecycle.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-chipfilter--docs) |
 * [Encore site](https://encore.spotify.net/web/components/chips) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/ChipFilter) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=34892-14611&t=09m9nEoe87Yk6rya-1)
 */
var ChipGroup = exports.ChipGroup = /*#__PURE__*/_react["default"].forwardRef(function ChipGroup(_ref, ref) {
  var mode = _ref.mode,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? 'single-line' : _ref$layout,
    children = _ref.children,
    _onKeyDown = _ref.onKeyDown,
    _ref$noItemsAssistive = _ref.noItemsAssistiveText,
    noItemsAssistiveText = _ref$noItemsAssistive === void 0 ? 'No items added' : _ref$noItemsAssistive,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var role = getRole(mode);
  var chipGroupRef = (0, _react.useRef)(null);
  var emptyGroupLabelRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showOverflowStartButton = _useState2[0],
    setShowOverflowStartButton = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    showOverflowEndButton = _useState4[0],
    setShowOverflowEndButton = _useState4[1];
  var _useState5 = (0, _react.useState)(new Map()),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    chipItems = _useState6[0],
    setChipItems = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    initialRenderDone = _useState8[0],
    setInitialRenderDone = _useState8[1];

  /**
   * This function doesn't do the removal itself, but assumes that the item has been removed
   * in the passed onRemove function, and sends focus to another chip or a hidden 'no items' label.
   */
  function handleOnRemove() {
    var _getNodeFromIndex, _getNodeFromIndex2;
    if (!chipItems) return;
    var deletedChipIndex = (0, _utils.getCurrentlyFocusedIndex)(chipItems);
    var deletedChipEncoreId = (_getNodeFromIndex = (0, _utils.getNodeFromIndex)(chipItems, deletedChipIndex)) === null || _getNodeFromIndex === void 0 ? void 0 : _getNodeFromIndex.getAttribute('data-encore-chip-id');
    var newChipIndex = (0, _utils.getNewIndexAfterDeletion)(chipItems, deletedChipIndex);
    // if group is empty, send focus to "no items" label
    if (newChipIndex === -1) {
      var _emptyGroupLabelRef$c;
      emptyGroupLabelRef === null || emptyGroupLabelRef === void 0 || (_emptyGroupLabelRef$c = emptyGroupLabelRef.current) === null || _emptyGroupLabelRef$c === void 0 || _emptyGroupLabelRef$c.focus();
      if (deletedChipEncoreId) {
        chipItems["delete"](deletedChipEncoreId);
      }
      return;
    }
    // else, focus next or previous chip
    (_getNodeFromIndex2 = (0, _utils.getNodeFromIndex)(chipItems, newChipIndex)) === null || _getNodeFromIndex2 === void 0 || _getNodeFromIndex2.focus();
    if (deletedChipEncoreId) {
      chipItems["delete"](deletedChipEncoreId);
    }
  }
  function handleKeyDown(e, passedOnKeyDown) {
    if (passedOnKeyDown) {
      passedOnKeyDown(e);
    }
    if (!chipItems) return;
    if (mode !== 'single-select' && mode !== 'multi-select') return;
    var activeElementIndex = (0, _utils.getCurrentlyFocusedIndex)(chipItems);
    var newActiveChipIndex = (0, _utils.getNextIndex)(e, activeElementIndex, chipItems === null || chipItems === void 0 ? void 0 : chipItems.size);
    var newActiveChip = (0, _utils.getNodeFromIndex)(chipItems, newActiveChipIndex);
    switch (e.key) {
      case _utils.LEFT_ARROW:
      case _utils.RIGHT_ARROW:
        {
          e.preventDefault();
          var currentActiveChip = (0, _utils.getNodeFromIndex)(chipItems, activeElementIndex);
          newActiveChip === null || newActiveChip === void 0 || newActiveChip.focus();
          newActiveChip === null || newActiveChip === void 0 || newActiveChip.scrollIntoView({
            block: 'nearest',
            inline: 'center',
            behavior: 'smooth'
          });
          currentActiveChip === null || currentActiveChip === void 0 || currentActiveChip.setAttribute('tabIndex', '-1');
          newActiveChip === null || newActiveChip === void 0 || newActiveChip.setAttribute('tabIndex', '');
          return;
        }
      default:
        {
          return;
        }
    }
  }
  var handleOverflowButtons = (0, _react.useCallback)(function () {
    if (chipGroupRef.current && layout === 'single-line') {
      var scrollLeft = Math.round(Math.abs(chipGroupRef.current.scrollLeft));
      var visibleWidth = chipGroupRef.current.offsetWidth;
      var totalWidth = chipGroupRef.current.scrollWidth;
      if (scrollLeft > 0) {
        setShowOverflowStartButton(true);
      } else {
        setShowOverflowStartButton(false);
      }
      if (scrollLeft + visibleWidth < totalWidth) {
        setShowOverflowEndButton(true);
      } else {
        setShowOverflowEndButton(false);
      }
    }
  }, [chipGroupRef, layout]);
  var scrollToDir = function scrollToDir(direction) {
    if (chipGroupRef.current) {
      var _chipGroupRef$current;
      var scrollLeft = chipGroupRef.current.scrollLeft;
      var visibleWidth = chipGroupRef.current.offsetWidth;
      var left = direction === 'start' ? scrollLeft - visibleWidth / 1.25 : scrollLeft + visibleWidth / 1.25;
      (_chipGroupRef$current = chipGroupRef.current) === null || _chipGroupRef$current === void 0 || _chipGroupRef$current.scrollTo({
        left: left,
        behavior: 'smooth'
      });
    }
  };
  var ltr = (0, _utils2.isLtr)(chipGroupRef);
  var getTabIndex = function getTabIndex(chipIndex) {
    return mode === 'single-select' || mode === 'multi-select' ? {
      tabIndex: chipIndex === 0 ? '' : '-1'
    } : {};
  };

  /** Maps through the provided <Chip> children and adds a unique `data-encore-chip-id` and
   * the correct tabIndex to aid with implementing custom keyboard behavior.
   *
   * We are knowingly using some legacy React things here (Children, cloneElement). Ideally
   * we could achieve the same things with React's `useId()` instead, but we need to be
   * able to drop support for React < 18 first.
   */
  var updateChildrenWithChipId = function updateChildrenWithChipId() {
    return _react.Children.map(children, function (child, index) {
      if ( /*#__PURE__*/(0, _react.isValidElement)(child)) {
        return /*#__PURE__*/(0, _react.cloneElement)(child, _objectSpread(_objectSpread({
          'data-encore-chip-id': "chip-".concat(index)
        }, getTabIndex(index)), child.props));
      }
      return null;
    });
  };
  (0, _react.useEffect)(function () {
    window.addEventListener('resize', handleOverflowButtons);
    handleOverflowButtons();
    return function () {
      return window.removeEventListener('resize', handleOverflowButtons);
    };
  }, [handleOverflowButtons]);

  /* Re-run handleOverflowButtons if children are added/removed */
  (0, _react.useEffect)(function () {
    handleOverflowButtons();
  }, [children, handleOverflowButtons]);
  (0, _react.useEffect)(function () {
    if (!chipItems && chipGroupRef.current) {
      var map = new Map();
      setChipItems(map);
    }
  }, [chipItems, chipGroupRef]);

  /**
   * Hack used to switch aria-live region from "off" to "polite" after items are cloned and re-rendered.
   * This prevents a screen reader from listing all Chips on page load.
   * */
  (0, _react.useEffect)(function () {
    if (!initialRenderDone) {
      setTimeout(function () {
        setInitialRenderDone(true);
      }, 1000);
    }
  }, [initialRenderDone]);
  var noChipItems = !chipItems || chipItems.size === 0;
  return /*#__PURE__*/_react["default"].createElement(_index.EncoreProvider, {
    config: {
      next: ['chip']
    }
  }, /*#__PURE__*/_react["default"].createElement(_ChipGroupContext.ChipGroupContext.Provider, {
    value: {
      chipItems: chipItems,
      mode: mode,
      handleOnRemove: handleOnRemove
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "aria-live": initialRenderDone ? 'polite' : 'off'
  }, /*#__PURE__*/_react["default"].createElement(_ChipGroup.ChipGroupContainer, {
    $showStartOverflow: showOverflowStartButton,
    $showEndOverflow: showOverflowEndButton
  }, /*#__PURE__*/_react["default"].createElement(_index3.OverflowButton, {
    position: "start",
    show: showOverflowStartButton,
    onClick: function onClick(e) {
      e.preventDefault();
      scrollToDir(ltr ? 'start' : 'end');
    },
    "data-testid": "overflow-start-button"
  }), /*#__PURE__*/_react["default"].createElement(_ChipGroup.ChipGroupComponent, Object.assign({
    role: role,
    ref: (0, _utils2.mergeRefs)([chipGroupRef, ref]),
    onScroll: handleOverflowButtons,
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.ChipGroup,
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e, _onKeyDown);
    },
    $layout: layout,
    $isEmpty: mode === 'input' && noChipItems
  }, props), mode === 'multi-select' || mode === 'single-select' || mode === 'input' ? updateChildrenWithChipId() : children), /*#__PURE__*/_react["default"].createElement(_index3.OverflowButton, {
    position: "end",
    show: showOverflowEndButton,
    onClick: function onClick(e) {
      e.preventDefault();
      scrollToDir(ltr ? 'end' : 'start');
    },
    "data-testid": "overflow-end-button"
  })), noItemsAssistiveText && mode === 'input' && /*#__PURE__*/_react["default"].createElement(_index2.VisuallyHidden, {
    ref: emptyGroupLabelRef,
    tabIndex: -1,
    "data-testid": "no-items-label"
  }, noChipItems && noItemsAssistiveText))));
});